export const downloadFile = async url => fetch(url).then(resp => resp.blob());
export const downloadFiles = urls => Promise.all(urls.map(url => downloadFile(url)));
export const blobToFile = (blob, fileName) => new File([blob], fileName, {
  lastModified: new Date().getTime(),
  type: blob.type,
});
